import { compose, defaultTo, has, length, map } from 'ramda';
import { filterFalsy } from 'yafrpl/arrays';

import { clear, unprefix } from '../../../../helpers/compact';
import { CommonSliceType } from '../../../../types/slice';
import { toImageFromProp } from '../../fields/image';
import { toLinkFromProp } from '../../fields/link';
import { toText, toTextFromProp } from '../../fields/text';

const getPushsUID = compose(
  filterFalsy,
  map(({ child_pushs }) => has('uid', child_pushs) && { uid: child_pushs.uid }),
  defaultTo([])
);

export const childPushsSlice = ({ primary, items }) => {
  const { title, desc } = unprefix('child_page', primary);
  const childPushs = getPushsUID(items);

  if (length(childPushs)) {
    return clear({
      type: CommonSliceType.CHILD_PUSHS,
      title: toText(title),
      description: toText(desc),
      childPushs,
    });
  }
};

export const coldPushSlice = ({ primary }) =>
  clear({
    type: CommonSliceType.COLD_PUSH,
    title: toTextFromProp('title', primary),
    fullName: toTextFromProp('fullName', primary),
    job: toTextFromProp('job', primary),
    image: toImageFromProp('image', primary),
    link: toLinkFromProp('link', primary),
  });
